export const ChevronRightIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M14.27 12.745a.5.5 0 0 0 0-.707l-3.712-3.712a.625.625 0 1 1 .884-.884l4.243 4.243a1 1 0 0 1 0 1.414l-4.243 4.242a.625.625 0 1 1-.884-.883z"
        clipRule="evenodd"
      ></path>
    </g>
  </svg>
);
